import WeAreOpenUntil from './weAreOpenUntil/WeAreOpenUntil';
import OpeningTimesTooltip from './openingTimesTooltip/OpeningTimesTooltip';
import { useEffect, useState } from 'react';
import { useLocation, matchPath } from 'react-router-dom';

type Props = {
    stylingRegion: "header" | "sidebar";
    isSidebarVisible?: boolean;
};

export default function ContactAndOpeningTimes(props: Props) {
    const { stylingRegion, isSidebarVisible = false } = props;
    const location = useLocation();
    const quoteJourneyPaths = [
        "/YourBusiness",
        "/EmployeeDetails",
        "/ChooseCover",
    ];

    const formatPhone = (number: string) => number.replace(/^0/, '+44').replace(/\s+/g, '');
    const siteConfig = JSON.parse(localStorage.getItem('siteConfig') || "{}");

    const [customerDetails, setCustomerDetails] = useState<any>(
        JSON.parse(localStorage.getItem('customerDetails') || "{}")
    );

    useEffect(() => {
        setCustomerDetails(JSON.parse(localStorage.getItem('customerDetails') || "{}"));
    }, [location.pathname]);

    const isOnQuoteJourneyPage = quoteJourneyPaths.some(
        path =>
            location.pathname === path ||
            location.pathname.startsWith(`${path}/`)
    );

    const canShowReferenceInHeader = isSidebarVisible && isOnQuoteJourneyPage && !!customerDetails?.policyNumber;

    const canShowReferenceInSidebar = isOnQuoteJourneyPage && !!customerDetails?.policyNumber;

    return (
        <div className={`${stylingRegion}-talk-to-us-container`}>
            <div className={`${stylingRegion}-talk-to-us-title`}>
                {stylingRegion === "header" && canShowReferenceInHeader ? (
                    <div className="quote-ref">
                        <div className="quote-ref-label">Your quote reference</div>
                        <div className="quote-ref-value">{customerDetails.policyNumber}</div>
                    </div>
                ) : (
                    <div>
                        <span className="callus-label">
                            {stylingRegion === "header" ? "Talk to us " : "Call us on "}
                            <a
                                className={`${stylingRegion}-phone-number`}
                                href={`tel:${formatPhone(siteConfig.phoneNumber)}`}
                            >
                                {siteConfig.phoneNumber}
                            </a>

                            {stylingRegion === "sidebar" && canShowReferenceInSidebar
                                ? `, and reference ${customerDetails.policyNumber}`
                                : ""}
                        </span>
                        <WeAreOpenUntil stylingRegion={stylingRegion} />

                        {stylingRegion === "sidebar" ? (
                            <div className="opening-hours">
                                <p>Monday - Thursday 8:30am - 7:00pm</p>
                                <p>Friday 8:30am - 5:00pm</p>
                            </div>
                        ) : (
                            <OpeningTimesTooltip stylingRegion={stylingRegion} />
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}